import { useState } from 'react';
import PageHeader from '../components/PageHeader.jsx';
import PartnerPerformanceTab from '../components/diagnostics/PartnerPerformanceTab.jsx';
import SupplyPathTab from '../components/diagnostics/SupplyPathTab.jsx';
import InboundContractTab from '../components/diagnostics/InboundContractTab.jsx';
import AttributionTab from '../components/diagnostics/AttributionTab.jsx';

/**
 * The "why" surface, as distinct from the configuration surfaces everywhere else in this console.
 *
 * Publishers, Demand Partners, Inbound Seats and Supply Quality all answer "what is set up".
 * None of them answers "what is actually happening, and why". Four admin endpoints did answer
 * that and had no reader -- partner-outcomes, supply-path-health, inbound-contract and
 * demand-attribution. Every finding in the 2026-09-30 and 2026-10-01 reviews came from calling
 * them by hand.
 *
 * Grouped as one page with flat tabs rather than four nav entries, matching SupplyQualityPage:
 * each is genuinely distinct, none is big enough to earn a top-level slot, and an operator asking
 * "why is demand low" should land in one place rather than guess which of four menu items holds
 * the answer.
 */
const TABS = [
  { key: 'partners', label: 'Partner Performance' },
  { key: 'supply-path', label: 'Supply Path' },
  { key: 'contract', label: 'Inbound Contract' },
  { key: 'attribution', label: 'Attribution' },
];

export default function DiagnosticsPage() {
  const [tab, setTab] = useState('partners');

  return (
    <div className="page">
      <PageHeader
        title="Diagnostics"
        subtitle="What is actually happening on the network, and why — partner outcomes, supply-path verifiability, the inbound contract, and what the data does and does not explain."
      />

      <div className="tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={`tabs__tab${tab === t.key ? ' tabs__tab--active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="tab-panel">
        {tab === 'partners' && <PartnerPerformanceTab />}
        {tab === 'supply-path' && <SupplyPathTab />}
        {tab === 'contract' && <InboundContractTab />}
        {tab === 'attribution' && <AttributionTab />}
      </div>
    </div>
  );
}
